m
<template>
  <div>
    <el-form label-position="top" :model="member" :rules="rules" ref="form">
      <el-row>
        <el-col :span="24" class="avatar-box entity-card">
          <vue-upload-component
            ref="headshotupload"
            inputId="headshotUpload"
            drop
            v-model="uploads"
            extensions="jpg,jpeg,png"
            accept="image/png,image/jpg,image/jpeg"
            :post-action="uploadURL"
            :headers="uploadHeaders"
            :data="{ _id: member._id }"
            @input-file="inputFile"
            @input-filter="inputFilter"
            v-if="clearance === 5"
          >
            <div class="avatar-wrap">
              <div
                :style="{ 'background-image': `url(${currentHeadshot})` }"
                alt=""
                class="avatar"
              ></div>
              <div class="upload-logo">
                <svg
                  width="18px"
                  height="16px"
                  viewBox="0 0 18 16"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g
                      id="Artboard"
                      transform="translate(-47.000000, -88.000000)"
                      fill="#FFFFFF"
                      fill-rule="nonzero"
                    >
                      <path
                        d="M48.9756098,103.852104 C47.8887171,103.852104 47,102.913299 47,101.765148 L47,92.4897855 C47,91.3416348 47.8887171,90.402829 48.9756098,90.402829 L51.7538,90.402829 L52.5220927,88.3810806 C52.5867013,88.2038545 52.74706,88.0861414 52.9268293,88.0839791 L59.0731707,88.0839791 C59.25294,88.0861414 59.4132987,88.2038545 59.4779073,88.3810806 L60.2462,90.402829 L63.0243902,90.402829 C64.1112829,90.402829 65,91.3416348 65,92.4897855 L65,101.765148 C65,102.913299 64.1112829,103.852104 63.0243902,103.852104 L48.9756098,103.852104 Z M48.9756098,102.924568 L63.0243902,102.924568 C63.6400341,102.924568 64.1219512,102.41549 64.1219512,101.765148 L64.1219512,92.4897855 C64.1219512,91.8394435 63.6400341,91.3303652 63.0243902,91.3303652 L59.9512195,91.3303652 C59.7731474,91.3293876 59.6132696,91.2148899 59.5464829,91.0405101 L58.7781902,89.0115154 L53.2218098,89.0115154 L52.4535171,91.0405101 C52.3867304,91.2148899 52.2268526,91.3293876 52.0487805,91.3303652 L48.9756098,91.3303652 C48.3599659,91.3303652 47.8780488,91.8394435 47.8780488,92.4897855 L47.8780488,101.765148 C47.8780488,102.41549 48.3599659,102.924568 48.9756098,102.924568 Z M56,101.30138 C53.8230317,101.30138 52.0487805,99.4271536 52.0487805,97.1274667 C52.0487805,94.8277565 53.8230317,92.9535536 56,92.9535536 C58.1770122,92.9535536 59.9512195,94.8277797 59.9512195,97.1274667 C59.9512195,99.4271536 58.1770122,101.30138 56,101.30138 Z M56,100.373843 C57.7024707,100.373843 59.0731707,98.9258667 59.0731707,97.1274667 C59.0731707,95.3290435 57.7024707,93.8810899 56,93.8810899 C54.2975732,93.8810899 52.9268293,95.3290435 52.9268293,97.1274667 C52.9268293,98.9258667 54.2975732,100.373843 56,100.373843 Z"
                        id="Shape"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </vue-upload-component>
          <div class="avatar-wrap" v-else>
            <div
              :style="{ 'background-image': `url(${currentHeadshot})` }"
              alt=""
              class="avatar"
            ></div>
          </div>
        </el-col>
      </el-row>
      <el-divider>Personal Details</el-divider>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="profile.firstName" label="First Name">
            <input
              class="input"
              autocomplete="off"
              placeholder="First Name"
              disabled
              v-model="member.profile.firstName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.middleName" label="Middle Name">
            <input
              class="input"
              autocomplete="off"
              placeholder="Middle Name"
              disabled
              v-model="member.profile.middleName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.lastName" label="Last Name">
            <input
              class="input"
              autocomplete="off"
              placeholder="Last Name"
              disabled
              v-model="member.profile.lastName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.dob" label="Date of Birth">
            <input
              class="input"
              type="date"
              v-model="member.profile.dob"
              format="yyyy-MM-dd"
              disabled
              value-format="yyyy-MM-dd"
              placeholder=""
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.email" label="Email">
            <input
              class="input"
              autocomplete="off"
              placeholder="Email"
              v-model="member.profile.email"
              :disabled="clearance === 6"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.mobile" label="Mobile">
            <input
              class="input"
              autocomplete="off"
              placeholder="Mobile"
              v-model="member.profile.mobile"
              :disabled="clearance === 6"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider>Emergency Contact</el-divider>
      <el-row>
        <el-col :span="24">
          <el-form-item prop="profile.emergency.name" label="Name">
            <input
              class="input"
              autocomplete="off"
              placeholder="Name"
              v-model="member.profile.emergency.name"
              :disabled="clearance === 6"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.emergency.mobile" label="Mobile">
            <input
              class="input"
              autocomplete="off"
              placeholder="Mobile"
              v-model="member.profile.emergency.mobile"
              :disabled="clearance === 6"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider>Health Details</el-divider>
      <el-row>
        <el-col :span="24">
          <el-form-item prop="profile.meta.medical.hasAllergies" label="Allergies">
            <select
              class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
              v-model="member.profile.meta.medical.hasAllergies"
              filterable
              :disabled="clearance === 6"
            >
              <option
                v-for="item in [
                  { value: false, label: 'No' },
                  { value: true, label: 'Yes' }
                ]"
                :label="item.label"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</option
              >
            </select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="profile.meta.medical.allowedTreatment" label="Medical Treatment">
            <select
              class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
              v-model="member.profile.meta.medical.allowedTreatment"
              placeholder=""
              filterable
              :disabled="clearance === 6"
            >
              <option
                v-for="item in [
                  { value: false, label: 'No' },
                  { value: true, label: 'Yes' }
                ]"
                :label="item.label"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</option
              >
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.meta.medical.hasMedical" label="Medical Conditions">
            <select
              class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
              v-model="member.profile.meta.medical.hasMedical"
              filterable
              :disabled="clearance === 6"
            >
              <option
                v-for="item in [
                  { value: false, label: 'No' },
                  { value: true, label: 'Yes' }
                ]"
                :label="item.label"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</option
              >
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="profile.meta.medical.notes" label="Medical Notes">
            <input
              class="input"
              type="text"
              autocomplete="off"
              v-model="member.profile.meta.medical.notes"
              placeholder="Medical Notes"
              :disabled="clearance === 6"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <button class="btn-cancel tw-mr-2.5" type="" size="medium" @click="$router.go(-1)">
        Back
      </button>
      <button
        class="btn-success"
        type="success"
        v-if="clearance === 5"
        size="`medium"
        @click="update"
      >
        Save
      </button>
    </el-form>
  </div>
</template>

<script>
import _ from "lodash";
import { disabilityTypes, errormsg } from "../../utils/constants";
import { validatePhoneNumber, validateEmail } from "../../utils/utilities";

export default {
  name: "MemberDetails",
  data() {
    const uploadURL = `${process.env.VUE_APP_API_URL}/nrl/api/v1/admin/headshot/upload`;
    const validateEmergencyNumber = (obj, value, callback) => {
      if (value && !validatePhoneNumber(value)) {
        return callback(new Error(errormsg.phone));
      }
      return callback();
    };
    const validateProfileEmail = (obj, value, callback) => {
      if (value && !validateEmail(value)) {
        return callback(new Error(errormsg.email));
      }
      return callback();
    };
    const required = { required: true, message: errormsg.input_option, trigger: "blur" };
    return {
      member: {
        _id: "",
        profile: {
          firstName: "",
          middleName: "",
          lastName: "",
          dob: "",
          gender: "",
          mobile: "",
          email: "",
          meta: {
            medical: {
              hasMedical: false,
              hasAllergies: false,
              allowedTreatment: false,
              notes: ""
            }
          },
          emergency: {
            name: "",
            mobile: ""
          }
        }
      },
      uploads: [],
      uploadURL,
      disabilityTypes,
      rules: {
        "profile.firstName": required,
        "profile.lastName": required,
        "profile.dob": required,
        "profile.gender": required,
        "profile.mobile": {
          required: true,
          trigger: "blur",
          validator: validateEmergencyNumber
        },
        "profile.email": {
          required: true,
          trigger: "blur",
          validator: validateProfileEmail
        },
        "profile.emergency.mobile": {
          required: true,
          trigger: "blur",
          validator: validateEmergencyNumber
        }
      }
    };
  },
  mounted() {
    const { id } = this.$route.params;
    this.$store.commit("root/loading", true);
    this.$http
      .get(`/nrl/api/v1/admin/members/my-members/${id}/manager`)
      .then(response => {
        this.member = _.merge({}, this.member, response.data.data);
        this.$store.commit("root/loading", false);
      })
      .catch(error => {
        this.$customError(_.get(error, "response.data.message"));
        this.$store.commit("root/loading", false);
      });
  },
  methods: {
    goDetails(member) {
      const { _id } = member;
      this.$router.push({
        name: "my-members.details",
        params: {
          id: _id
        }
      });
    },
    update() {
      this.$refs.form
        .validate()
        .then(val => {
          if (!val) return;
          this.$store.commit("root/loading", true);
          this.$http
            .put(`/nrl/api/v1/admin/members/${this.member._id}`, this.member)
            .then(() => {
              this.$customSuccess();
              this.$store.commit("root/loading", false);
            })
            .catch(error => {
              this.$customError(_.get(error, "response.data.message"));
              this.$store.commit("root/loading", false);
            });
        })
        .catch(() => {});
    },
    inputFile(newFile) {
      if (newFile && newFile.error) {
        this.$store.commit("app/loading", false);
        this.$customError("Headshot upload has failed");
        this.uploads = this.uploads.filter(file => file.id !== newFile.id);
      } else if (newFile && !newFile.active && newFile.response) {
        setTimeout(() => {
          this.$set(this.member.profile.meta, "avatar", newFile.response.url);
          this.$store.commit("app/loading", false);
        }, 2500);
      }
      return undefined;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (!/\.(png|jpg|jpeg)$/i.test(newFile.name)) {
        this.$customError("Please submit a valid file type (png/jpg/jpeg)");
        return prevent();
      }
      this.$store.commit("app/loading", true);
      this.$refs.headshotupload.active = true;
      return undefined;
    }
  },
  computed: {
    currentHeadshot() {
      return (
        _.get(this.member.profile, "meta.avatar") || require("@/assets/player_placeholder.png")
      );
    },
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
    uploadHeaders() {
      const { profile, tokens, activeRole } = this.$store.state.user;
      const authheader = `${profile._id}:${tokens.access_token}`;
      const encodedString = btoa(authheader);
      const Authorization = `Bearer ${encodedString}`;
      return { Authorization, "active-role": activeRole._id };
    }
  }
};
</script>

<style scoped lang="scss">
.el-input,
.el-select,
.el-input-number {
  width: 100%;
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
}

.btn-success {
  @apply tw-justify-center tw-w-full tw-mt-4 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-white  tw-bg-green-700  tw-mb-4 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}

.btn-cancel {
  @apply tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-black  tw-bg-gray-200 tw-border-2 tw-border-green-700  hover:tw-border-gray-200 sm:tw-w-64;
}

.input {
  @apply tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.avatar-box {
  text-align: center;
  .avatar-wrap {
    background-color: #fff;
    margin: 0 auto;
    overflow: hidden;
    border: 5px solid #fff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    width: 8rem;
    height: 8rem;
    margin-top: 2rem;
    margin-bottom: 2rem;

    .upload-logo {
      width: 100%;
      height: 100%;
      position: relative;
      top: 25%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: black;
      opacity: 0.6;
    }

    .avatar {
      background-size: contain;
      background-position: center;
      height: 8rem;
    }
  }

  img {
    transform: scale(1.4);
  }

  overflow: hidden;

  .avatar-entity-name {
    text-align: center;
    display: block;
    font-size: 1.05rem;
    font-style: oblique;
    margin-bottom: 1rem;
  }
  .upload {
    margin: 0 auto;
    display: block;
    max-width: 30%;
    margin-bottom: 2rem;
  }
}
</style>
